export const PROMPT_DOCUMENTATION_APPROVED = `
Capture new answers to questions that contain key insights, product knowledge, process explanations, how-to guidance, or best practices. Prioritize answers that help others understand how something works, why a decision was made, or how to solve a recurring problem.

Also capture useful references shared in these answers, such as links to documentation, tools, reports, or data sources, that show where to find information
`.trim();
